module.exports = __webpack_public_path__ + "static/media/store.4891fcb9.png_old";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store.png_old
// module id = 1081
// module chunks = 0